import { render, staticRenderFns } from "./history-saver.vue?vue&type=template&id=7412a8e5&"
import script from "./history-saver.vue?vue&type=script&lang=js&"
export * from "./history-saver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports